// eslint-disable-next-line import/named
import { BaseError } from './BaseError';

/**
 * Error with extended info and reason
 */
export class ExtendedInfoError extends BaseError {
    /**
     * @private
     * @type {string|number} [code]
     */
    _code;

    /**
     * @private
     * @type {*}
     */
    _data;

    /**
     * @private
     * @type {Record<string, any>}
     */
    _reason;

    /**
     * @type {string}
     */
    scope;

    /**
     *
     * @param {string} [message]
     * @param {string|number} [code]
     * @param {*} [data]
     * @param {Record<string, any>} [reason]
     * @constructs Service
     */
    constructor(message, { code, data, reason } = {}) {
        super(message);
        this.name = 'ExtendedInfoError';
        if (code != null) {
            this._code = code;
        }
        this._data = data;
        this._reason = reason;
    }

    /**
     * Данные пришедшие в ответе в
     * @public
     * @readonly
     * @type {*}
     */
    get data() {
        return this._data;
    }

    /**
     * @public
     * @readonly
     * @return {string|number}
     */
    get code() {
        return this._code;
    }

    /**
     * Дополнительная информация о причине ошибки
     *
     * @public
     * @readonly
     * @return {Record<string, any>}
     */
    get reason() {
        return this._reason;
    }

    /**
     *
     * @return {{reason: Record<string, *>, code: (string|number), data: *, name: string}}
     */
    toJSON() {
        const { name, code, data, reason, message } = this;
        return {
            name,
            message,
            code,
            data,
            reason
        };
    }
}
